import React from 'react'

export default function Resume() {
  return (
    <div>
      <h2>Resume Page</h2>
    </div>
  )
}
